export class NewItemIdNotFoundError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "NewItemIdNotFoundError"
    }
}